import React, { Component } from 'react'
import { Tabs } from 'antd';
import img1 from '../../../static/images/solution-wuren-banner.jpg'
import imgUe1 from '../../../static/images/ue.png'
import product3 from '../../../static/images/product-3.png'


import advantage2 from '../../../static/images/advantage2.png'
import analysis1 from '../../../static/images/analysis1.png'

import panorama from '../../../static/images/panorama.png'
import storeCompare from '../../../static/images/store-compare.png'
import youShi from '../../../static/images/youshi.png'


import './index.less';
const { TabPane } = Tabs;
class unmannedRetail extends Component {
    state = {
        customerList: [
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
        ],
        partnerList: [
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
        ],
    }
    onEvents() { }
    render() {
        // const { customerList, partnerList } = this.state
        return (
            <div className="product_container unattended-container affiliate-container payment-container unmanner-reatail-container pos-container">
                <div className="top-home-carousel">
                    <div className="banner-bg"><img className="banner-img" src={img1} alt="" /></div>
                    <div className="mode-mark"></div>
                    <div className="mask-top-content">
                        <div className="content-pos">
                            <div className="content-left-text">
                                <div className="banner-top-title">悦喵AI-24h无人零售店解决方案</div>
                                <div className="banner-top-tips">使用多维感知技术，实现线下萌点/仓库“人、货、场”的数字孪生，重塑行业经营，重塑社会生活</div>
                                <div className="banner-top-btn">了解体验</div>
                            </div>
                            
                        </div>
                        
                    </div>
                </div>

                <div className="common-block-home product-page">
                    <div className="common-block-home-title">传统便利店经营痛点</div>
                    <div className="common-block-product">
                        <div className="product-detail product-detail-page unattended-first-page">
                            <div style={{position: 'relative',}}>
                                <img className="product-detail-img" src={analysis1} alt="" />
                                <div className="first-page-title">
                                    闭店“零”收入
                                </div>
                                <div className="img-mark"></div>
                            </div>
                            
                            <div className="product-detail-tips">朋友聚会临时闭店，期间无流水，房租白白浪费</div>
                            

                        </div>
                        <div className="product-detail product-detail-page unattended-first-page">
                            <div style={{ position: 'relative', }}>
                                <img className="product-detail-img" src={analysis1} alt="" />
                                <div className="first-page-title">
                                    雇人成本高
                                </div>
                                <div className="img-mark"></div>
                            </div>
                           
                            <div className="product-detail-tips">招人看店一年成本4~5万，付完工资利润减半</div>
                            

                        </div>
                        <div className="product-detail product-detail-page unattended-first-page">
                            <div style={{ position: 'relative', }}>
                                <img className="product-detail-img" src={analysis1} alt="" />
                                <div className="first-page-title">
                                    守店如同“坐牢”
                                </div>
                                <div className="img-mark"></div>
                            </div>
                            
                            <div className="product-detail-tips">放假期间无法通家人出游，只能苦苦守店</div>
                           

                        </div>
                        <div className="product-detail product-detail-page unattended-first-page">
                            <div style={{ position: 'relative', }}>
                                <img className="product-detail-img" src={analysis1} alt="" />
                                <div className="first-page-title">
                                    熬夜守店伤身
                                </div>
                                <div className="img-mark"></div>
                            </div>
                            
                            <div className="product-detail-tips">为了收益长期熬夜守店生活不规律，影响身体健康</div>
                            

                        </div>

                    </div>

                </div>

                <div className="common-block-home">
                    <div className="common-block-home-title" style={{marginBottom: 0,}}>产品与服务</div>
                    <div className="common-block-home-tips" style={{ color: '#000', }}>门店方案全局场景图</div>
                    <div className="top-home-carousel">
                        <div className="banner-bg"><img className="banner-img" src={panorama} alt="" /></div>
                    </div>
                    <div className="common-block-home-tips">悦喵AI，在不改变商店原有经营模式的前提下低成本改造，通过智能硬件实现店铺升级。店主开启无人+有人看店模式</div>
                    <Tabs className="common-block-case-tabs common-block-harware-tabs" tabPosition="top">
                        <TabPane tab="无人零售" key="1">
                            <div className="top-home-carousel">
                                <div className="banner-bg"><img className="banner-img" src={imgUe1} alt="" /></div>
                            </div>

                        </TabPane>
                        <TabPane tab="自助结算" key="2">
                            <div className="top-home-carousel">
                                <div className="banner-bg"><img className="banner-img" src={imgUe1} alt="" /></div>
                               
                            </div>

                        </TabPane>
                        <TabPane tab="智能软件" key="3">
                            <div className="top-home-carousel">
                                <div className="banner-bg"><img className="banner-img" src={imgUe1} alt="" /></div>
                               
                            </div>

                            
                        </TabPane>
                        <TabPane tab="智能盒子" key="4">
                            <div className="top-home-carousel">
                                <div className="banner-bg"><img className="banner-img" src={imgUe1} alt="" /></div>
                               
                            </div>

                           
                        </TabPane>
                        <TabPane tab="周边硬件" key="5">
                            <div className="top-home-carousel">
                                <div className="banner-bg"><img className="banner-img" src={imgUe1} alt="" /></div>
                               
                            </div>

                        </TabPane>
                       
                    </Tabs>
                </div>

                {/* <div className="common-block-home product-page customer-page">
                    <div className="common-block-home-title">实体零售行业当前所面临的痛点</div>
                    <div className="payment-type-content">
                        <div className="unmanned-content-left">
                            <div className="bank-title">劳动力短缺</div>
                            <div className="bank-tips">少子化、老龄化导致劳动力日益短缺，劳动力向其它行业和大城市集中，零售行业普遍存在用人难问题，基层员工流动性极其搞，导致培训成本高企服务和运营质量下降</div>
                        </div>
                        <div className="unmanned-content-right">
                            <div className="bank-num-content">
                                <div className="bank-title">人工成本高</div>
                                <div className="bank-tips">一二线城市人工成本较高，且需要安排至少3名店员才能保证门店7×24h全年无休营业，夜间时间段成本更高且员工幸福感低</div>
                            </div>
                            <div className="bank-num-content">
                                <div className="bank-title">运营效率低</div>
                                <div className="bank-tips">高峰时段收银台前往往排起长队，收银效率低下。此外基层员工每日花大量时间在订货、补货、盘点库存，落实营销活动，耗时好礼，面销更是因为千人一面的话术而收益甚微</div>
                            </div>

                        </div>
                    </div>


                </div> */}

                <div className="common-block-home advantage-common-block-home">
                    <div className="common-block-home-title color-style">无人解决方案为您提供的能力</div>
                    <div className="common-block-home-tips color-style">智能化、一体化解决方案，让实体零售像电商一样数据驱动、在线经营</div>
                    <div className="advantage-detail">
                        <div className="advantage-detail-content">
                            <div className="advantage-detail-left">
                                <div className="advantage-detail-left-title">自动收银结算.节省人力成本</div>
                                <div className="advantage-detail-left-tips">刷脸/刷码/刷卡进店，AI摄像头精准识别购物行为和商品信息，挑选完扫码或者自助收银机自动结算，在解决雇人收银问题的同时提升收银效率</div>
                            </div>
                            <div className="advantage-detail-right">
                                <img className="member-img-style" src={advantage2} alt="" />
                            </div>
                        </div>

                    </div>
                    <div className="advantage-detail">
                        <div className="advantage-detail-content">
                            <div className="advantage-detail-right">
                                <img className="member-img-style" src={advantage2} alt="" />
                            </div>
                            <div className="advantage-detail-left">
                                <div className="advantage-detail-left-title">远程控店.轻松实现24h营业</div>
                                <div className="advantage-detail-left-tips">改变传统的8-16小时店主/店员守店模式，延长经营时间至全天24小时，提高门店利用率，看得见的门店收益增长。</div>
                            </div>
                        </div>

                    </div>
                    <div className="advantage-detail">
                        <div className="advantage-detail-content">
                            <div className="advantage-detail-left">
                                <div className="advantage-detail-left-title">数据分析,助理经营决策</div>
                                <div className="advantage-detail-left-tips">床上基于门店海量消费信息积累和大数据分析，洞察消费偏好和趋势，助力精准优化选品、陈列以及定价</div>
                            </div>
                            <div className="advantage-detail-right">
                                <img className="member-img-style" src={advantage2} alt="" />
                            </div>
                        </div>

                    </div>
                    <div className="advantage-detail">
                        <div className="advantage-detail-content">
                            <div className="advantage-detail-right">
                                <img className="member-img-style" src={advantage2} alt="" />
                            </div>
                            <div className="advantage-detail-left">
                                <div className="advantage-detail-left-title">精准营销，提升销售转化</div>
                                <div className="advantage-detail-left-tips">将顾客从潜客到熟客的各阶段进行细分促进会员熟化过程，有效进行会员忠诚度管理</div>
                            </div>
                        </div>

                    </div>
                    <div className="advantage-detail">
                        <div className="advantage-detail-content">
                            <div className="advantage-detail-left">
                                <div className="advantage-detail-left-title">渠道融合，门店坪效翻倍</div>
                                <div className="advantage-detail-left-tips">基于三方外卖、线上商城和店内购物进行全渠道销售，丰富门店SKU，同时借助各种自动化手段完成多场景的配送履约</div>
                            </div>
                            <div className="advantage-detail-right">
                                <img className="member-img-style" src={advantage2} alt="" />
                            </div>
                        </div>
                    </div>

                </div>

                <div className="common-block-home">
                    <div className="common-block-home-title" style={{ marginBottom: 0, }}>门店升级前后对比</div>
                    <div className="top-home-carousel">
                        <div className="banner-bg"><img className="banner-img" src={storeCompare} alt="" /></div>
                    </div>
                </div>
                <div className="common-block-home">
                    <div className="common-block-home-title" style={{ marginBottom: 0, }}>悦喵AI方案优势</div>
                    <div className="common-block-home-tips" style={{ color: '#666', }}>升级快、24H营业、真人守护、时间自由、丢货包赔</div>
                    <div className="top-home-carousel">
                        <div className="banner-bg"><img className="banner-img" src={youShi} alt="" /></div>
                    </div>
                </div>

                <div className="common-block-home unattended-first">
                    <div className="common-block-home-title common-block-home-title-1">适应典型应用场景</div>
                    <div className="common-block-product">
                        <div className="store-model">
                            <img className="unattended-img-style" src={analysis1} alt="" />
                            <div className="store-model-title">CBD无人店</div>
                            <div className="store-model-tips">早午高峰期免排队，以差异化服务制胜</div>
                        </div>
                        <div className="store-model">
                            <img className="unattended-img-style" src={analysis1} alt="" />
                            <div className="store-model-title">社区无人店</div>
                            <div className="store-model-tips">7*24h全天营业,助力打造一刻钟便民生活店/月卡/季卡/年卡）等，你可以自由选择电子卡券形式也可以额外印制实体卡券。</div>

                        </div>
                        <div className="store-model">
                            <img className="unattended-img-style" src={analysis1} alt="" />
                            <div className="store-model-title">园区无人店</div>
                            <div className="store-model-tips">全数字化零售业态，加速园区智慧升级</div>
                        </div>
                    </div>
                </div>



                
            </div >
        )
    }
}


export default unmannedRetail